import { Component, OnInit, ViewChild, TemplateRef } from '@angular/core';
import { universityService } from '@app/_services/university.service';
import { first } from 'rxjs/operators';
import { university } from '@app/_models/university';
import { Subject } from 'rxjs';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { NgbModalConfig, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';
import { NgxSpinnerService } from "ngx-spinner";
import { DocumentVerificationListService } from '@app/_services/document-verification-list.service';
import { environment } from '@environments/environment';
import { statusRemark } from '@app/_models/statusRemark';
import { DataTableDirective } from 'angular-datatables';

@Component({
  selector: 'app-university-verification-list',
  templateUrl: './university-verification-list.component.html',
  styleUrls: ['./university-verification-list.component.css']
})
export class UniversityVerificationListComponent implements OnInit {
  RemarkForm: FormGroup;
  NewRemarkForm: FormGroup;
  submitted = false;
  modeOfStudy
  remark;
  returnUrl
  getId: number;
  request: university[];
  title = 'universityList';
  dtOptions: DataTables.Settings = {};
  dtTrigger: Subject<any> = new Subject<any>();
  upload_doc_path: any = "/University/assets/images/No-results-found.jpg";
  originalDocUploadFilePath: any = "/University/assets/images/No-results-found.jpg";
  upload_doc_pathString: string = '';
  originalDocUploadFilePathString: string = '';
  userId = localStorage.getItem('user_id');
  display = "none";
  statusRemark = new statusRemark();
  reasonVal: string;
  newReasonVal: string;
  dtElement: DataTableDirective;
  isVrPdf: boolean = false;
  isVrImage: boolean = false;
  isUPdf: boolean = false;
  isUImage: boolean = false;
  fileURL;
  src;
  fileURL1;
  src1;
  hideId = false;
  isImageR = false;
  isImageL = false;
  noImage1 = false;
  noImage2 = false;
  imgname = "uploadImg1"
  imgname2 = "uploadImg2"
  addNewRemarkId;
  submitted4 = false;
  EditReasonForm: FormGroup;
  editReasonVal: string;
  rejectionTrail

  @ViewChild('showRejectionTrailBox', { read: TemplateRef}) showRejectionTrailBoxTemplate: TemplateRef<any>;
  @ViewChild('showModalBoxImage', { read: TemplateRef }) showModalBoxImage: TemplateRef<any>;
  @ViewChild('showModalBox', { read: TemplateRef }) showModalBoxTemplate: TemplateRef<any>;
  @ViewChild('closebutton') closebutton;
  @ViewChild('closebuttonRemark') closebuttonRemark;

  get f() { return this.RemarkForm.controls; }
  get g() { return this.NewRemarkForm.controls; }
  get i() { return this.EditReasonForm.controls; }

  constructor(
    private documentVerificationListService: DocumentVerificationListService,
    private universityService: universityService,
    config: NgbModalConfig,
    private modalService: NgbModal,
    private router: Router,
    private SpinnerService: NgxSpinnerService,
    private formBuilder: FormBuilder
  ) { }


  showFlag: boolean = false;
  selectedImageIndex: number = -1;
  currentIndex

  showLightbox(index) {
    this.selectedImageIndex = index;
    this.showFlag = true;

    this.imageObject = [
      {
        image: this.upload_doc_path,
        alt: 'alt of image', // Optional
        title: 'To be verified' // Optional: Show image with description text 
      },
      {
        image: this.originalDocUploadFilePath, // Support base64 image
        title: 'System document', //Optional: You can use this key if want to show image with title
        alt: 'Image alt' //Optional: You can use this key if want to show image with alt
      }
    ];
  }

  closeEventHandler() {
    this.showFlag = false;
    this.currentIndex = -1;
  }

  // imageObject: Array<object> = [
  //   {
  //     image: this.upload_doc_path,
  //     alt: 'alt of image', // Optional
  //     title: 'To be verified' // Optional: Show image with description text 
  //   },
  //   {
  //     image: '../../assets/images/img.JPG', // Support base64 image
  //     title: 'System document', //Optional: You can use this key if want to show image with title
  //     alt: 'Image alt' //Optional: You can use this key if want to show image with alt
  //   }
  // ];

  imageObject: Array<object> = [];


  ngOnInit(): void {

    this.modeOfStudy = 'Regular';

    this.EditReasonForm = this.formBuilder.group({
      editReasonVal: ['', Validators.required]
    })

    this.RemarkForm = this.formBuilder.group({

      reasonVal: ['', Validators.required]
    });

    this.NewRemarkForm = this.formBuilder.group({

      newReasonVal: ['']
    });

    this.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 10,
      processing: true,
      destroy: true,
      order: [[1, 'desc']]
    };

    this.universityService.getUniversityVerifierRequestList()
      .pipe(first())
      .subscribe(
        data => {
          console.log("response---", data)
          this.request = data.respData;
          console.log(this.request)
          this.dtTrigger.next();
        },
        error => {
          console.log(error)
        })
    // this.openModal(52);
  }

  fetchEditReason(nm){
    console.log("------------");
    this.editReasonVal = '';
    this.statusRemark.id = this.getId;
    this.statusRemark.status = nm.target.name;
    this.statusRemark.verifiedby = this.userId;
    this.statusRemark.modeOfStudy = this.modeOfStudy;
  }


  changeEditStatusWithReason(e){
    this.submitted4 = true;
    console.log("********",this.editReasonVal)
    this.statusRemark.editreason = this.editReasonVal;
    var id = this.getId;
    this.statusRemark.roleid = localStorage.getItem('currentRole');
    this.statusRemark.modeOfStudy = this.modeOfStudy;
    console.log("reject mode", this.statusRemark.modeOfStudy)
    if(this.EditReasonForm.invalid){
      return;
    }
   // this.SpinnerService.show();
    this.documentVerificationListService.setStatusUniversity(this.statusRemark)
      .pipe(first())
      .subscribe(
        data => {
          console.log("response---", data)
          this.SpinnerService.hide();
          this.modalService.open(this.showModalBoxTemplate);
        },
        error => {
          console.log(error)
        }
      )
  }


  getModeOfStudy(e){
    console.log("mode =",e.target.value);
    this.modeOfStudy = e.target.value
    console.log("mode 2 =", this.modeOfStudy);

  }
  addNewRemark(event){
    console.log("event---",event);
    console.log("new remark---",this.NewRemarkForm)
    this.statusRemark.newremark = this.NewRemarkForm.value.newReasonVal;
    this.statusRemark.id = this.addNewRemarkId;
    console.log(this.statusRemark)
    this.universityService.addNewRemark(this.statusRemark)
      .pipe(first())
      .subscribe(
        data => {
          location.reload();
          console.log("response---", data)
          this.request = data.respData;
          console.log(this.request)
          this.dtTrigger.next();
        }
        
        ,
        error => {
          console.log(error)
        })
    this.newReasonVal = this.NewRemarkForm.value;
  }

  showRemark(strReason, newReasonId) {
    this.remark = strReason;
    this.addNewRemarkId = Number(newReasonId);
    console.log(this.remark, this.addNewRemarkId)
  }

  _base64ToArrayBuffer(base64) {
    var binary_string = base64.replace(/\\n/g, '');
    binary_string = window.atob(base64);
    var len = binary_string.length;
    var bytes = new Uint8Array(len);
    for (var i = 0; i < len; i++) {
      bytes[i] = binary_string.charCodeAt(i);
    }
    return bytes.buffer;
  }

  openPdf() {
    window.open(this.fileURL);
  }

  openPdf1() {
    window.open(this.fileURL1);
  }

  openModal(id) {
    this.getId = id;
    this.isImageR = false;
    this.isImageL = false;
    this.upload_doc_path = '';
    this.originalDocUploadFilePath = '';

    this.documentVerificationListService.getverifydocument(id)
      .pipe(first())
      .subscribe(
        data => {
          console.log("response---", data)
          this.documentVerificationListService.getverifydocumentImage(`${environment.apiUrl}` + data.respData[0].upload_doc_path).pipe(first())
            .subscribe(
              add => {
                console.log("addadd---", add)
                let reader = new FileReader();
                if (add.type == "application/pdf") {
                  this.isVrPdf = true;
                  this.isVrImage = false;
                  reader.addEventListener("load", () => {
                    this.upload_doc_path = reader.result;
                    var base64Array = this.upload_doc_path.substring(28);
                    console.log("=====base64Array===========", base64Array);
                    this.src = this._base64ToArrayBuffer(base64Array);
                    let file = new Blob([add], { type: 'application/pdf' });
                    this.fileURL = URL.createObjectURL(file);
                    // window.open(this.fileURL);                    
                  }, false);
                  // this.src = this._base64ToArrayBuffer();
                } else {
                  this.isVrImage = true;
                  this.isVrPdf = false;
                  console.log("reader---", reader)
                  reader.addEventListener("load", () => {
                    this.upload_doc_path = reader.result;
                    this.upload_doc_pathString = this.upload_doc_path;
                    this.noImage1 = false;
                    //alert(  this.upload_doc_path)
                  }, false);
                }
                if (add) {
                  reader.readAsDataURL(add);
                }
                this.isImageL = true;
                if (this.isVrPdf == true) {

                  var al = window.open('', 'OPEN');
                  window.setTimeout(function () { al.close() }, 100);
                }

                console.log("=======img===========L======", this.isImageR, this.isImageL);
                if (this.isImageL == true && this.isImageR == true) {
                  this.SpinnerService.hide();
                  this.modalService.open(this.showModalBoxImage, { windowClass: 'my-class',centered: true });
                }
              }, error => {
                this.SpinnerService.hide(); this.modalService.open(this.showModalBoxImage, { windowClass: 'my-class', centered: true });
                this.upload_doc_path = "/University/assets/images/No-results-found.jpg"; // test server
                this.noImage1 = true;
                console.log(error)
              })
          if (data.respData[0].originalDocUploadFilePath != undefined) {
            this.documentVerificationListService.getverifydocumentImage(`${environment.apiUrl}` + data.respData[0].originalDocUploadFilePath).pipe(first())
              .subscribe(
                data2 => {
                  console.log("data2---", data2, data2.type)
                  let reader = new FileReader();
                  if (data2.type == "application/pdf") {
                    this.isUPdf = true;
                    this.isUImage = false;
                    reader.addEventListener("load", () => {
                      this.originalDocUploadFilePath = reader.result;
                      var base64Array = this.originalDocUploadFilePath.substring(28);
                      console.log("=====base64Array===========", base64Array);
                      this.src1 = this._base64ToArrayBuffer(base64Array);
                      let file = new Blob([data2], { type: 'application/pdf' });
                      this.fileURL1 = URL.createObjectURL(file);
                      // window.open(this.fileURL);                    
                    }, false);
                    // this.src = this._base64ToArrayBuffer();
                  } else {
                    this.isUImage = true;
                    this.isUPdf = false;
                    reader.addEventListener("load", () => {
                      this.originalDocUploadFilePath = reader.result;
                      this.noImage2 = false;
                      // var base64Array = this.upload_doc_path.substring(28);
                      // this.src = this._base64ToArrayBuffer(base64Array); 
                      // console.log("------------",this.src);
                      // console.log(base64Array);
                      console.log(reader.result);
                    }, false);
                  }
                  console.log(this.isUImage, this.isUPdf)

                  if (data2) {
                    reader.readAsDataURL(data2);
                  }
                  this.isImageR = true;
                  if (this.isUPdf == true) {

                    var al = window.open('', 'OPEN');
                    window.setTimeout(function () { al.close() }, 100);
                  }
                  console.log("=======img===========R======", this.isImageR, this.isImageL);

                  if (this.isImageL == true && this.isImageR == true) {
                    this.SpinnerService.hide();
                    this.modalService.open(this.showModalBoxImage, { windowClass: 'my-class',centered: true });
                  }
                },
                error => {
                  this.SpinnerService.hide();
                  this.modalService.open(this.showModalBoxImage, {windowClass: 'my-class', centered: true });
                  this.originalDocUploadFilePath = "/University/assets/images/No-results-found.jpg"; // test server
                  this.noImage2= true;
                  console.log(error)
                }
              ),
              console.log(this.request)
            this.imageObject = [];
          }
          else {
            this.isUPdf = false;
            this.isUImage = true;
            this.isImageR = true;
            this.originalDocUploadFilePath = "/University/assets/images/No-results-found.jpg"; 
            this.noImage2 = true;
          }
          if (this.isImageL == true && this.isImageR == true) {
            this.SpinnerService.hide();
            this.modalService.open(this.showModalBoxImage, { windowClass: 'my-class', centered: true });
          }
        },
        error => {
          this.isUPdf = false;
          this.isUImage = true;
          this.isImageR = true;
          if (this.isImageL == true && this.isImageR == true) {
            this.SpinnerService.hide();
            this.modalService.open(this.showModalBoxImage, { windowClass: 'my-class',centered: true });
          }
          this.upload_doc_path = "/University/assets/images/No-results-found.jpg"; // test server
          this.originalDocUploadFilePath = "/University/assets/images/No-results-found.jpg"; // test server
          console.log(error)
          // this.noImage1 = true;
          // this.noImage2 = true;
        }
      )

    this.SpinnerService.show();
  }
  openRemarkModal(nm) {
    this.statusRemark.id = this.getId;
    this.statusRemark.status = nm.target.name;
    this.statusRemark.modeOfStudy = this.modeOfStudy;
    console.log("this.statusRemark.modeOfStudy 90", this.statusRemark.modeOfStudy)
    console.log("this.statusRemark 90", this.modeOfStudy)
    //this.statusRemark.remark = 'ABCD';
  }

  
  //console.log("modeOfStudy =", this.modeOfStudy)
  changeStatus(e) {
    var id = this.getId;
    var status = e.target.name;
    
    let verifiedby = localStorage.getItem('user_id');
    this.statusRemark.verifiedby = verifiedby;
    this.statusRemark.modeOfStudy = this.modeOfStudy;
    console.log("status remark ===", this.statusRemark.modeOfStudy)
    this.statusRemark.id = this.getId;
    this.statusRemark.status = e.target.name;
    this.statusRemark.newremark = this.newReasonVal;
    this.statusRemark.roleid = localStorage.getItem('currentRole');

    console.log("HERE IS THE CHANGE STATUS FUNCTION")
    console.log(id, this.statusRemark)
    this.documentVerificationListService.setStatusUniversity(this.statusRemark)
      .pipe(first())
      .subscribe(
        data => {
          console.log("response---", data)
          this.SpinnerService.hide();
          this.modalService.open(this.showModalBoxTemplate);
        },
        error => {
          console.log(error)
        }
      ),
      this.SpinnerService.show();
  }
  ngOnDestroy(): void {
    // Do not forget to unsubscribe the event
    this.dtTrigger.unsubscribe();
  }
  changeRemarkStatus(e) {
    this.submitted = true;
    this.statusRemark.remark = this.reasonVal;
    if (this.RemarkForm.invalid) {
      return;
    }
    let verifiedby = localStorage.getItem('user_id');
    this.statusRemark.verifiedby = verifiedby;
    var id = this.getId;
    this.statusRemark.modeOfStudy = this.modeOfStudy;
    console.log("main = this.statusRemark.modeOfStudy", this.statusRemark.modeOfStudy)
    this.statusRemark.remark = this.reasonVal;
    this.statusRemark.newremark = this.newReasonVal;
    this.statusRemark.roleid = localStorage.getItem('currentRole');
    //alert(this.reasonVal)
    this.documentVerificationListService.setStatusUniversity(this.statusRemark)
      .pipe(first())
      .subscribe(
        data => {
          console.log("response---", data)
          this.SpinnerService.hide();

          for (let i = 0; i < this.request.length; ++i) {
            if (this.request[i].id === id) {
              this.request.splice(i, 1);
            }
          }
          this.closebuttonRemark.nativeElement.click();
          this.modalService.open(this.showModalBoxTemplate);
        },
        error => {
          console.log(error)
        }
      ),
     this.SpinnerService.show();
  }

  fetchRejectionTrail(){
    console.log("-----Rejection Trail------", this.getId)
    this.modalService.open(this.showRejectionTrailBoxTemplate, { windowClass: 'my-class', size: 'sm', centered: true });
    this.documentVerificationListService.getRejectionReason(this.getId)
      .pipe(first())
      .subscribe(
        data => {
          console.log("response---", data)
          this.rejectionTrail = data.respData;
          console.log(this.rejectionTrail)
          // this.dtTrigger.next();
        },
        error => {
          console.log(error)
        }
      )
  }

  refresh(): void {
    location.reload();

    // this.closebutton.nativeElement.click();
    // this.modalService.dismissAll(this.showModalBoxTemplate);
    // this.display = "none";
    // this.returnUrl = "university";
    // // this.request= this.request;
    // this.router.navigate([this.returnUrl]);
  }
}
